import db from '@/plugins/dexie';
import geraDataV2 from '@/utils/geraDataV2';
import geraData from '@/utils/geradata';
// eslint-disable-next-line import/no-cycle
import { WsEnviaDados } from '../../websocket';

export default {
  enviaLancamentoAtividade: () => {
    const lancamentos = db.lancamentoatividade.where('laaidnuvem').equals('null').toArray();

    lancamentos.then((tabela) => {
      tabela.forEach((laa) => {
        let item = laa;
        if (!laa.laaidusuario) {
          item = {
            ...laa,
            laaidusuario: sessionStorage.getItem('user:useidnuvem'),
          };
        }
        console.log(item);
        WsEnviaDados({ tipo: 'postLancamentoAtividade', msg: item });
      });
    });
  },
  retornoLancamentoAtividade: ({ data }) => {
    const item = data.body;
    // query pela DataCriacao para fazer um handshake entre a WS para atribuir o idnuvem no lancamento
    const queryPromise = db.lancamentoatividade.where('laadatacriacao').equals(geraDataV2({
      date: item.laadatacriacao,
      add: 3,
      ignoreDev: true,
    })).toArray();
    queryPromise.then((tabela) => {
      console.log(tabela, (geraDataV2({
        date: item.laadatacriacao,
        add: 3,
        ignoreDev: true,
      })));
      tabela.forEach((linha) => {
        const newObj = { laaidnuvem: item.id, laadatanuvem: geraData() };
        db.lancamentoatividade.update(linha.id, newObj);
      });
    });
  },
};
